<div class="separador"></div>
<!--
<div class="d-flex" id="wrapper">
  <div class="navbar-light bg-light border-right" id="sidebar-wrapper">
    <div class="sidebar-heading">{{ fecdia | date : "dd/MM/yyyy" }}</div>
    <div class="sidebar-heading"></div>
    <div class="sidebar-heading"></div>
    <div class="list-group list-group-flush">
      <a
        class="list-group-item list-group-item-action bg-light"
        [routerLink]="mnu.ruta"
        *ngFor="let mnu of menu; let i = index"
      >
        <fa-icon [icon]="mnu.icono"></fa-icon>
        {{ mnu.nombre }}
      </a>
    </div>
  </div>

  <div id="page-content-wrapper">
    <nav class="navbar navbar-expand-lg navbar-light bg-cave border-bottom">
      <button class="btn btn-light" (click)="persiana()" id="menu-toggle">
        <span class="navbar-toggler-icon"></span>
      </button>
      <span class="usuario">{{ nomusu }} </span>
    </nav>
     -->
<div class="container">
  <div class="header-section">
    <h1>Anticipos</h1>
    <hr />
  </div>

  <div class="action-bar">
    <button class="btn-back" (click)="volver()">
      <fa-icon [icon]="icoRet"></fa-icon> Volver
    </button>
  </div>

  <div class="loading" *ngIf="resul">
    <div class="spinner"></div>
  </div>

  <div class="table-container">
    <table
      datatable
      [dtOptions]="dtOptions"
      [dtTrigger]="dtTrigger"
      id="tabla"
      class="data-table"
    >
      <thead>
        <tr>
          <th>Fecha</th>
          <th>Serie Ant.</th>
          <th>Anticipo Nº</th>
          <th>Ej. Partida</th>
          <th>Partida</th>
          <th>Base IVA</th>
          <th>Cuota IVA</th>
          <th>Cuota Req.</th>
          <th>Neto</th>
          <th>Base Ret.</th>
          <th>% Retención</th>
          <th>Imp. Retención</th>
          <th>Total</th>
          <th>Texto</th>
          <th>Ej. Liq.</th>
          <th>Nº Liq.</th>
          <th>Serie Liq.</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let dato of datosTabla; index as i"
          [ngClass]="{ 'row-total': dato.tbTex === 'T O T A L E S' }"
        >
          <td>
            {{
              dato.tbFec || (dato.tbTex === "T O T A L E S" ? "TOTALES" : "")
            }}
          </td>
          <td>{{ dato.tbSerAnt }}</td>
          <td>{{ dato.tbNumAnt }}</td>
          <td>{{ dato.tbEjePar }}</td>
          <td>{{ dato.tbNumPar }}</td>
          <td class="number">{{ dato.tbBasIva | number : ".2" }}</td>
          <td class="number">{{ dato.tbCuoIva | number : ".2" }}</td>
          <td class="number">{{ dato.tbCuoReq | number : ".2" }}</td>
          <td class="number">{{ dato.tbNeto | number : ".2" }}</td>
          <td class="number">{{ dato.tbBasRet | number : ".2" }}</td>
          <td class="number">{{ dato.tbReten | number : ".2" }}</td>
          <td class="number">{{ dato.tbImpRet | number : ".2" }}</td>
          <td class="number">{{ dato.tbTotal | number : ".2" }}</td>
          <td>{{ dato.tbTex }}</td>
          <td>{{ dato.tbEjeLiq }}</td>
          <td>{{ dato.tbNumLiq }}</td>
          <td>{{ dato.tbSerLiq }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Mobile Cards -->
  <div class="mobile-cards">
    <div *ngFor="let dato of datosTabla; index as i" class="card-item">
      <div class="card-header" (click)="toggleCard(i)">
        <div><strong>Fecha:</strong> {{ dato.tbFec }}</div>
        <div><strong>Anticipo Nº:</strong> {{ dato.tbNumAnt }}</div>
        <div class="expand-hint">Toca para ver más...</div>
      </div>

      <div *ngIf="expandedIndex === i" class="card-details">
        <div class="detail-row">
          <span>Serie Ant.:</span> {{ dato.tbSerAnt }}
        </div>
        <div class="detail-row">
          <span>Ej. Partida:</span> {{ dato.tbEjePar }}
        </div>
        <div class="detail-row"><span>Partida:</span> {{ dato.tbNumPar }}</div>
        <div class="detail-row">
          <span>Base IVA:</span> {{ dato.tbBasIva | number : ".2" }}
        </div>
        <div class="detail-row">
          <span>Cuota IVA:</span> {{ dato.tbCuoIva | number : ".2" }}
        </div>
        <div class="detail-row">
          <span>Cuota Req.:</span> {{ dato.tbCuoReq | number : ".2" }}
        </div>
        <div class="detail-row">
          <span>Neto:</span> {{ dato.tbNeto | number : ".2" }}
        </div>
        <div class="detail-row">
          <span>Base Ret.:</span> {{ dato.tbBasRet | number : ".2" }}
        </div>
        <div class="detail-row">
          <span>% Retención:</span> {{ dato.tbReten | number : ".2" }}
        </div>
        <div class="detail-row">
          <span>Imp. Retención:</span> {{ dato.tbImpRet | number : ".2" }}
        </div>
        <div class="detail-row">
          <span>Total:</span> {{ dato.tbTotal | number : ".2" }}
        </div>
        <div class="detail-row"><span>Texto:</span> {{ dato.tbTex }}</div>
        <div class="detail-row"><span>Ej. Liq.:</span> {{ dato.tbEjeLiq }}</div>
        <div class="detail-row"><span>Nº Liq.:</span> {{ dato.tbNumLiq }}</div>
        <div class="detail-row">
          <span>Serie Liq.:</span> {{ dato.tbSerLiq }}
        </div>
      </div>
    </div>
  </div>
</div>
<!--   </div>
  /#page-content-wrapper 
</div>-->
